import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const Rewards = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#5FAFFF">
      <Path d="M18.813 28h5.627c1.16 0 2.16-.947 2.16-2.107v-9.186h-7.787V28ZM5.4 25.893c0 1.16.947 2.107 2.107 2.107h5.666V16.707H5.387v9.186H5.4Z" />
      <Path d="M25.893 9.627h-2.88c.44-.587.72-1.32.72-2.107A3.525 3.525 0 0 0 20.213 4C17.76 4 17.053 5.773 16 8.44 14.947 5.76 14.24 4 11.787 4a3.525 3.525 0 0 0-3.52 3.52c0 .8.28 1.52.72 2.107h-2.88c-1.16 0-2.107.946-2.107 2.106v1.454c0 1.16.947 2.106 2.107 2.106h7.08V9.627h-1.4A2.111 2.111 0 0 1 9.68 7.52c0-1.16.947-2.107 2.107-2.107 1.44 0 1.853.867 2.933 3.6.08.187.173.414.253.627h-.36v18.373h2.814V9.627h-.36L17.32 9c1.08-2.733 1.493-3.6 2.933-3.6 1.16 0 2.107.947 2.107 2.107 0 1.16-.947 2.106-2.107 2.106h-1.4v5.667h7.08c1.16 0 2.107-.947 2.107-2.107V11.72c0-1.16-.947-2.107-2.107-2.107l-.04.014Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Rewards
